import { useContext } from 'react'
import * as React from 'react'
import { observer } from 'mobx-react-lite'
import { AlgoliaArticle } from '../../types'
import { EditorStateContext, EditorViewContext } from '../../common/Prose/EditorProvider/EditorProviderContext'
import { useArticle } from '../../hooks/queries/articles/useArticle'
import { Button } from '../Button'
import { MiniDocCardBody } from '../MiniDocCard/MiniDocCard'
import Styles from './TemplateMiniDocCard.module.scss'
import templatesStore from 'stores/TemplatesStore'

const ErrorDocCard = () => {
  return (
    <div className={Styles.errorDocCard}>
      <span>Could not load template</span>
    </div>
  )
}

export const TemplateMiniDocCard = observer(
  ({ article, className = '' }: { article: AlgoliaArticle; className?: string }) => {
    const editorState = useContext(EditorStateContext)
    const editorView = useContext(EditorViewContext)
    const selectedTemplate = templatesStore.selectedPickerTemplate

    const articleQuery = useArticle(article.key, {
      retry: false,
      enabled: templatesStore.selectedPickerTemplate === article.key,
      onError: () => {
        templatesStore.setState({ selectedPickerTemplate: null })
      },
    })

    const onClickHandler = (e: React.MouseEvent) => {
      e.preventDefault()

      if (editorState && editorView) {
        templatesStore.setState({ selectedPickerTemplate: article.key })
      }
    }

    const onDiscardHandler = () => {
      if (!editorState || !editorView) return
      const tr = editorState.tr

      setTimeout(() => {
        if (!articleQuery.isSuccess) return

        tr.setMeta('TEMPLATE_PREVIEW', true)
        tr.replaceWith(0, editorState.doc.content.size, [editorView.state.schema.nodes.paragraph.create(null)])
        editorView.dispatch(tr)
      }, 100)

      templatesStore.setState({ selectedPickerTemplate: null })
    }

    if (articleQuery.isError) {
      return <ErrorDocCard />
    }

    return (
      <div className={Styles.wrapper}>
        {selectedTemplate === article.key && (
          <div className={Styles.selected}>
            <span>{articleQuery.isLoading ? 'Loading...' : 'Applied'}</span>

            {articleQuery.isSuccess && (
              <Button onPress={onDiscardHandler} className={Styles.clearButton}>
                Clear
              </Button>
            )}
          </div>
        )}

        <a href={'/#'} onClick={onClickHandler}>
          <MiniDocCardBody article={article} className={className} variant={'templatePickerSlider'} />
        </a>
      </div>
    )
  },
)
